import type { TablePluginOptions } from '@atlaskit/editor-plugin-table';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/editor-experiment';

export function tablePluginOptions(): TablePluginOptions {
	return {
		tableOptions: {
			allowTableResizing: true,
			allowTableAlignment: true,
			allowBackgroundColor: true,
			allowColumnResizing: true,
			allowColumnSorting: true,
			allowDistributeColumns: true,
			allowHeaderColumn: true,
			allowHeaderRow: true,
			allowMergeCells: true,
			allowNumberColumn: true,
			allowNestedTables: true,
			allowControls: true,
			stickyHeaders: true,
			allowAddColumnWithCustomStep: false,
		},
		isTableScalingEnabled: true,
		allowContextualMenu: true,
		fullWidthEnabled: false,
		wasFullWidthEnabled: false,
		getEditorFeatureFlags: () => ({
			tableWithFixedColumnWidthsOption: true,

			tableSelector: editorExperiment('platform_editor_tables_table_selector', true),
		}),
		isCommentEditor: false,
		isChromelessEditor: false,
	};
}
